import { FC } from 'react';
import { Store } from 'lucide-react';
import { StoreVisitLocation } from '../mock/types';
import { fmtInt } from '../utils';

type StoreVisitsCardProps = {
  totalVisits: number;
  locations: StoreVisitLocation[];
  onMoreInfo: () => void;
};

export const StoreVisitsCard: FC<StoreVisitsCardProps> = ({ totalVisits, locations, onMoreInfo }) => {
  const maxVisits = Math.max(1, ...locations.map((l) => l.visits));
  return (
    <div
      style={{
        background: '#FFFFFF',
        border: '1px solid #E7EAEF',
        borderRadius: 14,
        padding: '22px 26px 22px',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          gap: 12,
          marginBottom: 18,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <div
            style={{
              width: 36,
              height: 36,
              borderRadius: 10,
              background: '#E8EFFF',
              display: 'grid',
              placeItems: 'center',
              color: '#1452E6',
            }}
          >
            <Store size={18} color='currentColor' />
          </div>
          <div>
            <div style={{ fontSize: 16, fontWeight: 700, color: '#0B1733', letterSpacing: '-0.01em' }}>Visite in negozio</div>
            <div style={{ fontSize: 12.5, color: '#7A8597', marginTop: 2 }}>
              Misurate da Google Ads tramite Business Profile e location extension dei tuoi {locations.length} punti vendita.
            </div>
          </div>
        </div>
        <span
          style={{
            fontSize: 10.5,
            textTransform: 'uppercase',
            letterSpacing: '0.06em',
            fontWeight: 600,
            color: '#16955E',
            background: '#DDF3E7',
            padding: '4px 8px',
            borderRadius: 6,
          }}
        >
          Attivo
        </span>
      </div>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1.1fr 1.4fr',
          gap: 28,
          alignItems: 'end',
        }}
      >
        <div>
          <div style={{ fontSize: 12.5, color: '#7A8597', fontWeight: 500 }}>Visite totali nel periodo</div>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 12, marginTop: 6 }}>
            <span
              style={{
                fontSize: 48,
                fontWeight: 700,
                color: '#1452E6',
                letterSpacing: '-0.025em',
                lineHeight: 1,
                fontVariantNumeric: 'tabular-nums',
              }}
            >
              {fmtInt(totalVisits)}
            </span>
          </div>
          <div style={{ fontSize: 12.5, color: '#7A8597', marginTop: 10 }}>
            Stima modellata su dati anonimi e aggregati ·{' '}
            <a
              href='#'
              onClick={(e) => {
                e.preventDefault();
                onMoreInfo();
              }}
              style={{ color: '#1452E6', textDecoration: 'none', fontWeight: 500 }}
            >
              Maggiori info →
            </a>
          </div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 14 }}>
          {locations.map((l) => {
            const pct = Math.round((l.visits / maxVisits) * 100);
            return (
              <div
                key={l.customerId}
                style={{
                  background: '#FFFFFF',
                  border: '1px solid #E7EAEF',
                  borderRadius: 12,
                  padding: '14px 16px',
                }}
              >
                <div style={{ fontSize: 11.5, color: '#7A8597', fontWeight: 500 }}>{l.location}</div>
                <div
                  style={{
                    fontSize: 24,
                    fontWeight: 700,
                    color: '#0B1733',
                    fontVariantNumeric: 'tabular-nums',
                    marginTop: 2,
                  }}
                >
                  {fmtInt(l.visits)}
                </div>
                <div
                  style={{
                    height: 4,
                    background: '#E7EAEF',
                    borderRadius: 2,
                    marginTop: 10,
                    overflow: 'hidden',
                  }}
                >
                  <div style={{ height: '100%', width: `${pct}%`, background: '#1452E6', borderRadius: 2 }} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
